/**
 * Ofertas BLACKFEO aplicadas nas páginas oficiais (STAR, Agente e certificações).
 * Fonte única dos preços e checkouts de campanha; ofertas habituais seguem em
 * produtos-oferta.ts e certificacao/oferta.ts.
 */
import type { CertOferta } from "@/lib/certificacao/oferta";
import type { ProdutoCheckoutPlano } from "@/lib/checkout/produtos-oferta";
import { faseBlackfeo } from "./regras";
import { urlCheckoutBlackfeo } from "./catalogo";

export const BLACKFEO_CATALOGO = "/blackfeo";

/** Pausa manual: true mantém a BLACKFEO só na prévia (?preview=1) mesmo após 04/11. Trocar para false para liberar. */
export const BLACKFEO_PAUSADA = false;

function faseEfetiva(now: number) {
  const fase = faseBlackfeo(new Date(now));
  return BLACKFEO_PAUSADA && fase === "periodo-vendas" ? "preparacao" : fase;
}

/** Durante a ação vale para todos; antes dela (ou pausada) só na prévia; depois de 30/11 nunca. */
export function blackfeoVisivel(now: number, preview: boolean): boolean {
  const fase = faseEfetiva(now);
  return fase === "periodo-vendas" || (fase === "preparacao" && preview);
}

export const STAR_PLANOS_BLACKFEO: ProdutoCheckoutPlano[] = [
  { id: "anual", produto: "star", nome: "STAR · 1 ano", valor: 97, precoDe: 307, parcelas: "12x R$10,03", periodo: "Acesso por 1 ano · renovação anual", checkout: urlCheckoutBlackfeo("1675886"), oferta: "blackfeo" },
  { id: "tres-anos", produto: "star", nome: "STAR · 3 anos", valor: 207, precoDe: 497, parcelas: "12x R$21,41", periodo: "Acesso por 3 anos · renovação a cada 3 anos", checkout: urlCheckoutBlackfeo("1923333"), oferta: "blackfeo" },
  { id: "vitalicia", produto: "star", nome: "STAR · Vitalícia", valor: 247, precoDe: 597, parcelas: "12x R$25,55", periodo: "Acesso vitalício · pagamento único", checkout: urlCheckoutBlackfeo("1716431"), oferta: "blackfeo" },
];

export const AGENTE_PLANO_BLACKFEO: ProdutoCheckoutPlano = {
  id: "agente", produto: "agente", nome: "Agente de Raciocínio Clínico", valor: 97, precoDe: 497,
  parcelas: "12x R$10,03", checkout: urlCheckoutBlackfeo("G96165PYW1"), oferta: "blackfeo",
};

export const CERT_CHECKOUT_BLACKFEO = {
  lombar: "G92VQY5Z9E", cervical: "2439321", eletro: "VWGZ1J2P07", ombro: "D0RAA28B9Y",
  tornozelo: "69KAZ55A0O", joelho: "1W32DY3592", quadril: "G96RR16QW1",
} as const;
export type CertBlackfeoSlug = keyof typeof CERT_CHECKOUT_BLACKFEO;

export const CERT_OFERTA_BLACKFEO: CertOferta = {
  promo: true,
  cupom: "BLACKFEO",
  descontoLabel: "BLACKFEO · 75% OFF",
  descontoCurto: "75% OFF",
  precoDe: "DE R$697 POR",
  precoDeValor: "R$697",
  parcelado: "R$177,00",
  aVista: "ou 12x R$18,31",
  aVistaValor: "R$177",
  parcelasNota: "12x R$18,31",
  bump: "",
};

export function certCheckoutBlackfeo(slug: CertBlackfeoSlug): string {
  return urlCheckoutBlackfeo(CERT_CHECKOUT_BLACKFEO[slug]);
}

/** Plano válido para o pré-checkout (servidor), considerando a oferta escolhida. */
export function planoBlackfeo(produto: "star" | "agente", id: string): ProdutoCheckoutPlano | undefined {
  return produto === "star" ? STAR_PLANOS_BLACKFEO.find((p) => p.id === id) : id === "agente" ? AGENTE_PLANO_BLACKFEO : undefined;
}

/** Antes da virada, links internos levam a prévia adiante; depois, ficam só os oficiais. */
export function comPreviewAntesDaVirada(href: string, now: number): string {
  if (faseEfetiva(now) !== "preparacao" || !href.startsWith("/")) return href;
  const [base, hash = ""] = href.split("#");
  const sep = base.includes("?") ? "&" : "?";
  return `${base}${sep}preview=1${hash ? `#${hash}` : ""}`;
}

/** /pos, /pos-gg e /certificacao levam ao catálogo BLACKFEO durante a ação (ou na prévia). */
export function redirecionaCatalogoBlackfeo(searchStr: string, now: number): string | null {
  const preview = new URLSearchParams(searchStr).get("preview") === "1";
  return blackfeoVisivel(now, preview) ? `${BLACKFEO_CATALOGO}${searchStr}` : null;
}
